
const parseServerItem = function (file) {
  return {
    id: file.id,
    for_attach: false,
    for_destroy: false,
    name: file.name,
    doc_type: file.doc_type,
    url: file.doc.access_link
  }
}

const parseUiItem = function(file) {
  return {
    id: '_' + Math.random().toString(36).substr(2, 9),
    for_attach: true,
    for_destroy: false,
    name: file.name,
    doc: file,
    type: file.type,
    url: URL.createObjectURL(file)
  }
}

const state = {
  list: [] // available types pdf, doc, docx, png and jpeg
}

const actions = {}

const mutations = {

  FETCH(state, separate_documents) {
    state.list = []
    separate_documents.map((file) => state.list.push(parseServerItem(file)))
  },

  ADD(state, payload) {
    let {file, list, doc_type} = payload
    if (file) {
      let fileObject = parseUiItem(file)
      fileObject['doc_type'] = doc_type
      state.list.push(fileObject)
    }else if(list) {
      list.map(function(file){
        let fileObject = parseUiItem(file)
        fileObject['doc_type'] = doc_type
        state.list.push(fileObject)
      })
    }
  },

  REMOVE(state, id) {
    let index = state.list.findIndex(doc => doc.id == id)
    let doc = state.list[index]
    if (doc.for_attach){
      state.list.splice(index, 1)
    }else{
      doc.for_destroy = true
    }
  }
}

const getters = {
  tickets: (state) => state.list.filter((file) => file.doc_type == 1),
  passports: (state) => state.list.filter((file) => file.doc_type == 0)
}

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
}